import {
  buildPaymentSummaryQuery,
  hasRequiredFilterKeys,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const FMB_SUMMARY_QUERY_KEYS = ["startDate", "endDate", "paymentMode", "q"] as const;

export type FmbSummaryQueryKey = (typeof FMB_SUMMARY_QUERY_KEYS)[number];

export const FMB_PAYMENT_SUMMARY_PATH = "fmbReceipt/summary/payment-mode";

/** Date keys that must both be set before the summary request runs. */
export const FMB_SUMMARY_REQUIRED_DATE_KEYS = ["startDate", "endDate"] as const;

export function buildFmbSummaryQuery(filterValues: Record<string, unknown>): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, FMB_SUMMARY_QUERY_KEYS);
}

export function shouldFetchFmbPaymentSummary(filterValues: Record<string, unknown>): boolean {
  return hasRequiredFilterKeys(filterValues, FMB_SUMMARY_REQUIRED_DATE_KEYS);
}

/** Maps API summary JSON to the card labels/amounts rendered in the list. */
export function fmbPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
